import { Box, styled } from '@mui/material'
import { FC, ReactChild } from 'react'

const Background = styled(Box)`
  position: absolute;
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`

const UpperBackground = styled(Box)`
  background-color: #151517;
  opacity: 0.7;
  width: 97%;
  flex: 2;
`

const LowerBackground = styled(Box)`
  background-color: #151517;
  opacity: 0.7;
  width: 86%;
  flex: 1.3;
`

const Content = styled(Box)`
  position: relative;
  width: 100%;
  height: 100%;
`

const ApeironCardStatus: FC<Props> = (props: Props) => {
  const { className, children } = props

  return (
    <Box className={className}>
      <Background>
        <UpperBackground className='Custom-Upper-Background' />
        <LowerBackground className='Custom-Lower-Background' />
      </Background>
      <Content className='Custom-Content'>{children}</Content>
    </Box>
  )
}

type Props = {
  className?: string
  children: ReactChild | ReactChild[]
}

export default ApeironCardStatus
